// Budgets for the tray page's initial tray load (see utils/loadWithRetry). The
// request normally answers in well under a second; these only matter when it
// does not.
//
// An attempt's budget covers getting the auth token as well as the request. One
// that overruns it is aborted, request included, so it can never land later and
// dispatch a stale FETCH_TRAY over newer capture state. The budget grows with
// each attempt, the last one repeating, so a request that is slow but working
// still gets through instead of being cut off every time.
export const TRAY_LOAD_ATTEMPT_TIMEOUTS_MS = [10000, 20000, 40000, 60000];
export const TRAY_LOAD_RETRY_DELAYS_MS = [1000, 2000, 5000];
